import "./hsl-color-picker.scss";
import m from "mithril";

export default () => {
	let hsl = {
		h: 20,
		s: 50,
		l: 50,
	};

	let suffixtext = "--brand-color";

	function updatecolors() {
		document.documentElement.style.setProperty(`${suffixtext}-h`, hsl.h);
		document.documentElement.style.setProperty(`${suffixtext}-s`, `${hsl.s}%`);
		document.documentElement.style.setProperty(`${suffixtext}-l`, `${hsl.l}%`);
		// localoptions.SetData("local-theme", hsl);
	}

	return {
		oninit: ({attrs: {suffix = "--brand-color"}}) => {
			let style = getComputedStyle(document.body);
			suffixtext = suffix;
			hsl.h = Number(style.getPropertyValue(`${suffixtext}-h`));
			hsl.s = Number(style.getPropertyValue(`${suffixtext}-s`).replaceAll("%", ""));
			hsl.l = Number(style.getPropertyValue(`${suffixtext}-l`).replaceAll("%", ""));
		},
		view: ({attrs: {state}}) => {
			return m(".hsl-color-picker", [
				m(".picker-section", [
					m(".editor-section", [
						m("input", {
							type: "range",
							min: "0",
							max: "360",
							value: hsl.h,
							oninput: (e) => {
								hsl.h = e.target.value;
								updatecolors();
							},
						}),
						m("input", {
							type: "range",
							min: "0",
							max: "100",
							value: hsl.s,
							oninput: (e) => {
								hsl.s = e.target.value;
								updatecolors();
							},
						}),
						m("input", {
							type: "range",
							min: "0",
							max: "100",
							value: hsl.l,
							oninput: (e) => {
								hsl.l = e.target.value;
								updatecolors();
							},
						}),
					]),
					m(".display-section", [
						// m(".current-color-section", [m(".color-swatch"), m("span", "Current Color")]),
						m(".new-color-section", [
							m(".color-swatch", {
								style: `background-color:var(${suffixtext});`,
							}),
							m("span", `h:${hsl.h}     s:${hsl.s}     l:${hsl.l}      `),
						]),
					]),
				]),
			]);
		},
	};
};
